// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".briq-dialog-backdrop > .briq-dialog {\n  max-height: 97vh;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
